<div class="loader-container" *ngIf="!view">
  <app-loading-dots size="5px"></app-loading-dots>
</div>
<div class="document-select-list" *ngIf="view">
  <div>
    <app-view [items]="view?.data?.content" [info]="view?.data"></app-view>
  </div>
</div>
